import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Logo } from "@/components/layout/Header";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await login(email, password); nav("/admin"); } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-[var(--ink)]"><img src="/img/garden.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" /><p className="absolute bottom-10 left-10 right-10 font-display text-5xl font-black text-white">Gestão da Feira de Saúde e Bem-Estar</p></div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <Logo />
          <h1 className="font-display text-3xl font-extrabold pt-6">Área reservada</h1>
          <label className="block"><span className="text-sm font-semibold">Email</span>
            <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-12 w-full rounded-xl border border-black/20 bg-white px-4" data-testid="admin-login-email" /></label>
          <label className="block"><span className="text-sm font-semibold">Palavra-passe</span>
            <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-12 w-full rounded-xl border border-black/20 bg-white px-4" data-testid="admin-login-password" /></label>
          {error && <p role="alert" className="text-sm font-semibold text-red-700" data-testid="admin-login-error">{error}</p>}
          <button disabled={busy} className="h-12 w-full rounded-full bg-[var(--leaf)] text-white font-bold disabled:opacity-60" data-testid="admin-login-submit">{busy ? "A entrar…" : "Entrar"}</button>
        </form>
      </div>
    </div>
  );
}
